import { Injectable } from "@angular/core";
import { EnrollCourseMaster } from "../model/EnrollCourseMaster.model";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionClient } from "../configration/sessionclient.storage";
import { PredefinedMaster } from "../model/PredefinedMaster.model";
import { CourseMaster } from "../model/CourseMaster.model";
import { StudentMaster } from "../model/StudentMaster.model";
import { StudentLectureMaster } from "../model/StudentLectureMaster.model";
import { StudentLectureMcqMaster } from "../model/StudentLectureMcqMaster.model";
import { StudentLectureContentMaster } from "../model/StudentLectureContentMaster.model";
import { AskAQuery } from "../model/AskAQuery.model";
import { User } from "../model/User.model";
import { NotificationMaster } from "../model/NotificationMaster.model";
import { LectureMaster } from "../model/LectureMaster.model";
import { ReceiptMaster } from "../model/ReceiptMaster.model";
import { CartMaster } from "../model/CartMaster.model";
import { ExamMaster } from "../model/ExamMaster.model";
import { TrainerMaster } from "../model/TrainerMaster.model";
import { TestimonialMaster } from "../model/TestimonialMaster.model";
import { ExamMCQMaster } from "../model/ExamMCQMaster.model";
import { CompanyDetailMaster } from "../model/CompanyDetailMaster.model";
import { FaqMaster } from "../model/FaqMaster.model";
import { CourseHistory } from "../model/CourseHistory.model";

@Injectable({
  providedIn: "root",
})
export class MainserviceService {
  enrollCourseMaster: EnrollCourseMaster = new EnrollCourseMaster();
  predefinedMaster: PredefinedMaster = new PredefinedMaster();
  courseMaster: CourseMaster = new CourseMaster();
  studentMaster: StudentMaster = new StudentMaster();
  studentLectureMaster: StudentLectureMaster = new StudentLectureMaster();
  studentLectureMcqMaster: StudentLectureMcqMaster =
    new StudentLectureMcqMaster();
  studentLectureContentMaster: StudentLectureContentMaster =
    new StudentLectureContentMaster();
  askQuery: AskAQuery = new AskAQuery();
  user: User = new User();
  LectureMaster: LectureMaster = new LectureMaster();
  constructor(public http: HttpClient, private sessionClient: SessionClient) {}
  getStudentLecture(
    studentLectureMaster: StudentLectureMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getStudentLectureMasterById",
      studentLectureMaster
    );
  }
  saveEnrollCourseMaster(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/payForEnrollCourse",
      enrollCourseMaster
    );
  }

  saveStudentMaster(studentMaster: StudentMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "student/saveStudent",
      studentMaster
    );
  }
  getEnrollCourseMasterOptimizeList(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseMasterOptimizeList",
      enrollCourseMaster
    );
  }
  setenrollcourseMasterSession(enrollCourseMasterId: number) {
    this.sessionClient.saveSession(
      "courseEnrollMasterSessionId",
      JSON.stringify(enrollCourseMasterId)
    );
  }
  getenrollcourseMasterSession() {
    // this.enrollCourseMaster=JSON.parse(localStorage.getItem("courseEnrollMasterSessionId"));
    // }
    return JSON.parse(localStorage.getItem("courseEnrollMasterSessionId"));
  }
  getPredefinedListByType(predefinedMaster: PredefinedMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "predefined/getPredefinedListByType",
      predefinedMaster
    );
  }
  getPredefinedByTypeAndSubName(
    predefinedMaster: PredefinedMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "predefined/getPredefinedByTypeAndSubName",
      predefinedMaster
    );
  }
  getPredefinedListByTypeDistinctSubName(
    predefinedMaster: PredefinedMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "predefined/getPredefinedListByTypeDistinctSubName",
      predefinedMaster
    );
  }
  getPaymentTypeList(courseMaster: CourseMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getPaymentTypeList",
      courseMaster
    );
  }
  getStudentDetailsByUsername(studentMaster: StudentMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "student/getStudentDetailsByUsername",
      studentMaster
    );
  }
  getStudentMasterById(studentMaster: StudentMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "student/getStudentMasterById",
      studentMaster
    );
  }
  getEnrollCourseMasterOnDashboard(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseMasterOnDashboard",
      enrollCourseMaster
    );
  }
  getEnrollCourseDropdownOnDashboard(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseDropdownOnDashboard",
      enrollCourseMaster
    );
  }
  updateStudentDetail(studentMaster: StudentMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "student/updateStudentDetail",
      studentMaster
    );
  }
  getStudentLectureMasterOnDashboard(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getStudentLectureMasterOnDashboard",
      enrollCourseMaster
    );
  }
  getStudentLectureMasterById(
    studentLecture: StudentLectureMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "studentLecture/getStudentLectureMasterById",
      studentLecture
    );
  }
  setstudentLectureMaster(studentLectureMaster: StudentLectureMaster) {
    this.studentLectureMaster = studentLectureMaster;
    this.sessionClient.saveSession(
      "studentLecturMasterSession",
      JSON.stringify(this.studentLectureMaster)
    );
  }
  setLectureMaster(LectureMaster: LectureMaster) {
    this.LectureMaster = LectureMaster;
    this.sessionClient.saveSession(
      "LecturMasterSession",
      JSON.stringify(this.LectureMaster)
    );
  }

  getstudentLectureMasterSession() {
    this.studentLectureMaster = JSON.parse(
      localStorage.getItem("studentLecturMasterSession")
    );

    return this.studentLectureMaster;
  }
  getLectureMasterSession() {
    this.LectureMaster = JSON.parse(
      localStorage.getItem("LecturMasterSession")
    );

    return this.LectureMaster;
  }
  saveStudentLectureMCQAnswer(
    studentLectureMcqMaster: StudentLectureMcqMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/saveStudentLectureMCQAnswer",
      studentLectureMcqMaster
    );
  }

  // updateLastWatchedTime(studentLectureContentMaster:StudentLectureContentMaster): Observable<any> {

  //   return this.http.post<any>(environment.apiUrl+'enroll/updateLastWatchedTime', studentLectureContentMaster);
  // }
  getMyEnrolledCourseList(enroll: EnrollCourseMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseMasterList",
      enroll
    );
  }
  getMyEnrolledCourseLength(enroll: EnrollCourseMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseMasterListLength",
      enroll
    );
  }
  payPendingReceipts(enrollCourseMaster: EnrollCourseMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/payPendingReceipts",
      enrollCourseMaster
    );
  }

  setstudentSession(studentMaster: StudentMaster) {
    this.studentMaster = studentMaster;
    this.sessionClient.saveSession(
      "studentMaster",
      JSON.stringify(this.studentMaster)
    );
  }

  getstudentSession() {
    this.studentMaster = JSON.parse(localStorage.getItem("studentMaster"));
    return this.studentMaster;
  }
  getDesiredCourseMasterList(courseMaster: CourseMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "course/getDesiredCourseMasterList",
      courseMaster
    );
  }
  checkAlreadyEnrollCourse(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/checkAlreadyEnrollCourse",
      enrollCourseMaster
    );
  }
  getPredefinedListByGender(
    predefinedMaster: PredefinedMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "predefined/getPredefinedListByType",
      predefinedMaster
    );
  }
  updateEnrollCourseMaster(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/updateEnrollCourseMaster",
      enrollCourseMaster
    );
  }
  updateEnrollCourseMasterWithFile(
    uploadStudentProfileFiles: any[],
    uploadFatherProfileFiles: any[],
    uploadMotherProfileFiles: any[],
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    let formData: FormData = new FormData();
    for (let x = 0; x < uploadStudentProfileFiles.length; x++) {
      formData.append("studentProfileImage", uploadStudentProfileFiles[x]);
    }

    for (let x = 0; x < uploadFatherProfileFiles.length; x++) {
      formData.append("fatherProfileImage", uploadFatherProfileFiles[x]);
    }

    for (let x = 0; x < uploadMotherProfileFiles.length; x++) {
      formData.append("motherProfileImage", uploadMotherProfileFiles[x]);
    }

    formData.append(
      "enrollCourseMasterJson",
      new Blob([JSON.stringify(enrollCourseMaster)], {
        type: "application/json",
      })
    );

    return this.http.post<any>(
      environment.apiUrl + "enroll/updateEnrollCourseMasterWithFile",
      formData
    );
  }

  askAQuery(askQuery: AskAQuery): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "askaquery/saveAskAQuery",
      askQuery
    );
  }

  getAskAQueryList(askAQuery: AskAQuery): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "askaquery/getAskAQueryList",
      askAQuery
    );
  }

  fetchStudentByUsername(user: User): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "student/fetchStudentByUsername",
      user
    );
  }

  getDocumentPath(uploadthumnailImagePath: any[]): Observable<any> {
    let formData: FormData = new FormData();
    for (let x = 0; x < uploadthumnailImagePath.length; x++) {
      formData.append("file", uploadthumnailImagePath[x]);
    }
    return this.http.post<any>(
      environment.apiUrl + "document/getDocumentPath",
      formData
    );
  }

  setdefaultStudentLectureMaster(studentLectureMaster: StudentLectureMaster) {
    this.studentLectureMaster = studentLectureMaster;
    this.sessionClient.saveSession(
      "defaultStudentLectureMaster",
      JSON.stringify(this.user)
    );
  }
  getdefaultStudentLectureMaster() {
    this.studentLectureMaster = JSON.parse(
      localStorage.getItem("defaultStudentLectureMaster")
    );
    return this.studentLectureMaster;
  }
  getNotification(notificationMaster: NotificationMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "notification/getNotificationMasterList",
      notificationMaster
    );
  }
  getPaymentTypeForReceipt(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getPaymentTypeListForReceipt",
      enrollCourseMaster
    );
  }
  getFestivalCourseMaster(courseMaster: CourseMaster) {
    return this.http.post<any>(
      environment.apiUrl + "course/getFestivalCourseMaster",
      courseMaster
    );
  }
  getLectureMasterById(lectureMaster: LectureMaster) {
    return this.http.post<any>(
      environment.apiUrl + "lecture/getLectureMasterById",
      lectureMaster
    );
  }

  getStudentMasterList(studentMaster: StudentMaster) {
    return this.http.post<any>(
      environment.apiUrl + "student/getStudentMasterList",
      studentMaster
    );
  }
  getStudentMasterListLength(studentMaster: StudentMaster) {
    return this.http.post<any>(
      environment.apiUrl + "student/getStudentMasterListLength",
      studentMaster
    );
  }

  getCourseMasterList(courseMaster: CourseMaster) {
    return this.http.post<any>(
      environment.apiUrl + "course/getCourseMasterList",
      courseMaster
    );
  }
  getCourseMasterListLength(courseMaster: CourseMaster) {
    return this.http.post<any>(
      environment.apiUrl + "course/getCourseMasterListLength",
      courseMaster
    );
  }

  getEnrollCourseMasterListLength(
    enrollCourseMaster: EnrollCourseMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseMasterListLength",
      enrollCourseMaster
    );
  }

  getCourseMasterById(CourseMaster: CourseMaster) {
    return this.http.post<any>(
      environment.apiUrl + "course/getCourseMasterById",
      CourseMaster
    );
  }

  getEnrollCourseMasterById(enrollCourseMaster: EnrollCourseMaster) {
    return this.http.post<any>(
      environment.apiUrl + "enroll/getEnrollCourseMasterById",
      enrollCourseMaster
    );
  }

  getMasterCourse(CourseMaster: CourseMaster) {
    return this.http.post<any>(
      environment.apiUrl + "course/getMasterCourseMasterRequest",
      CourseMaster
    );
  }

  getReceiptMasterList(receiptMaster: ReceiptMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "receipt/getReceiptMasterList",
      receiptMaster
    );
  }

  getReceiptMasterListLength(receiptMaster: ReceiptMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "receipt/getReceiptMasterListLength",
      receiptMaster
    );
  }

  getCartMasterList(cartMaster: CartMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "cart/getCartMasterList",
      cartMaster
    );
  }

  getCartMasterListLength(cartMaster: CartMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "cart/getCartMasterListLength",
      cartMaster
    );
  }

  saveCartMaster(cartMaster: CartMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "cart/saveCartMaster",
      cartMaster
    );
  }

  deleteCartMaster(cartMaster: CartMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "cart/deleteCartMaster/",
      cartMaster
    );
  }

  getDashboardStats(studentMaster: StudentMaster) {
    return this.http.post<any>(
      environment.apiUrl + "student/getDashboardStats",
      studentMaster
    );
  }

  printReceipt(receiptMaster: ReceiptMaster): Observable<any> {
    return this.http.post(
      environment.apiUrl + "report/printReceipt",
      receiptMaster
    );
  }

  saveExamMasterAndGetExamMCQ(examMaster: ExamMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "exam/saveExamMasterAndGetExamMCQ",
      examMaster
    );
  }

  changeFlagExamMCQMaster(examMcqMaster: ExamMCQMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "exam/changeFlagExamMCQMaster",
      examMcqMaster
    );
  }

  checkExamMCQMasterAnswer(examMcqMaster: ExamMCQMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "exam/checkExamMCQMasterAnswer",
      examMcqMaster
    );
  }

  prevExamMCQMaster(examMcqMaster: ExamMCQMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "exam/prevExamMCQMaster",
      examMcqMaster
    );
  }

  saveExamMasterResult(examMaster: ExamMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "exam/saveExamMasterResult",
      examMaster
    );
  }

  getReceiptBifurcationAmount(receipt: ReceiptMaster) {
    return this.http.post<any>(
      environment.apiUrl + "receipt/getReceiptBifurcationAmount",
      receipt
    );
  }
  applyCouponCode(receipt: ReceiptMaster) {
    return this.http.post<any>(
      environment.apiUrl + "receipt/applyCouponCode",
      receipt
    );
  }

  getTrainerMasterList(trainerMaster: TrainerMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "trainer/getTrainerMasterList",
      trainerMaster
    );
  }
  getTrainerMasterListLength(trainerMaster: TrainerMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "trainer/getTrainerMasterListLength",
      trainerMaster
    );
  }

  getTestimonialList(testimonial: TestimonialMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "testimonial/getTestimonialMasterList",
      testimonial
    );
  }

  getTestimonialListLength(testimonial: TestimonialMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "testimonial/getTestimonialMasterListLength",
      testimonial
    );
  }

  getStudentLectureMcqMasterListForAssessment(
    studentLectureMCQMaster: StudentLectureMcqMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl +
        "studentLecture/getStudentLectureMcqMasterListForAssessment",
      studentLectureMCQMaster
    );
  }

  completeStudentLectureMaster(
    studentLectureMaster: StudentLectureMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "studentLecture/completeStudentLectureMaster",
      studentLectureMaster
    );
  }

  getCompanyDetail(companyDetailMaster: CompanyDetailMaster): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "companyDetail/getCompanyDetail",
      companyDetailMaster
    );
  }

  getFaqList(faq: FaqMaster): Observable<any> {
    return this.http.post<any>(environment.apiUrl + "faq/getFaqList", faq);
  }

  updateLastWatchedTime(
    studentLectureContentMaster: StudentLectureContentMaster
  ): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + "studentLecture/updateLastWatchedTime",
      studentLectureContentMaster
    );
  }

  getCourseHistory(courseHistory: CourseHistory) {
    return this.http.post<any>(
      environment.apiUrl + "course/getCourseHistory",
      courseHistory
    );
  }

  saveCourseHistory(courseHistory: CourseHistory) {
    return this.http.post<any>(
      environment.apiUrl + "course/saveCourseHistory",
      courseHistory
    );
  }

  payForOrder(receipt: ReceiptMaster) {
    return this.http.post<any>(
      environment.apiUrl + "receipt/payForOrder",
      receipt
    );
  }
  paymentSuccess(receipt: ReceiptMaster) {
    return this.http.post<any>(
      environment.apiUrl + "receipt/paymentSuccess",
      receipt
    );
  }

  deleteUserAccount(userId: Number) {
    return this.http.delete<any>(
      `${environment.apiUrl}user/deleteUser/${userId}`
    );
  }

  sendCertificateOnEmail(examMaster: ExamMaster) {
    return this.http.post(
      `${environment.apiUrl}exam/shareResultOnEmail`,
      examMaster
    );
  }
}
